import { err, ok, type Result } from 'neverthrow';

import { type SdkError } from '../../types.ts';

/**
 * Ensures a target index does not exceed the current collection length before
 * a reorder. Returns `STATE_ERROR('INDEX_OUT_OF_RANGE')` when out of bounds;
 * otherwise `ok`.
 */
export function assertIndexInRange(
  index: number,
  length: number
): Result<void, SdkError> {
  if (index > length) {
    return err({
      type: 'STATE_ERROR',
      reason: 'INDEX_OUT_OF_RANGE',
      message: `Index ${index} exceeds collection length ${length}`
    });
  }

  return ok(undefined);
}
